import { render } from "./PCResumenFamiliasVolcados.vue?vue&type=template&id=0c347bd8&scoped=true"
import script from "./PCResumenFamiliasVolcados.vue?vue&type=script&lang=js"
export * from "./PCResumenFamiliasVolcados.vue?vue&type=script&lang=js"

import "./PCResumenFamiliasVolcados.vue?vue&type=style&index=0&id=0c347bd8&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0c347bd8"]])

export default __exports__